<template>
  <div id="liveStreaming">
    <div class="tabList">
      <van-tabs v-model="activeName" @click="getLiveListData">
        <van-tab
          :title="item.channelName"
          :name="item.id"
          v-for="item in navTabsList"
          :key="item.id"
        ></van-tab>
      </van-tabs>
    </div>
    <div class="liveContent">
      <div class="inputContent">
        <div class="liveStreaming">
          <div class="title">
            <div class="titleContent">本月直播</div>
          </div>
          <swiper
            class="swiper-wrapper"
            :options="currentSwiperOption"
            v-if="currentLiveList.length > 0"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="item in currentLiveList"
              :key="item.id"
            >
              <!-- <a :href="item.jumpLink"> -->
              <div @click="liveJumpLink(item.jumpLink)">
                <img class="swiperImg" :src="`${uploadUrl}${item.imgUrl}`" />
                <div class="scrollTitle">{{ item.liveTitle }}</div>
                <div class="titleItem">
                  <!-- <img class="img" src="@/assets/gzh/zhibo_04.png" alt="" /> -->
                  <!-- 直播动画 -->
                  <div class="moveLive">
                    <div class="lineOne"></div>
                    <div class="lineTwo"></div>
                    <div class="lineThree"></div>
                  </div>
                  <span class="titleImg">正在直播</span>
                </div>
              </div>
              <!-- </a> -->
            </swiper-slide>
          </swiper>
          <div class="notAwaitLive" v-if="currentLiveList.length < 1">
            <div class="not">暂无直播</div>
          </div>
        </div>
        <div class="nowLiveStreaming">
          <div class="title">
            <div class="titleContent">直播预告</div>
            <div class="date" @click="seleteDate">
              {{ awaitLiveDate }}
              <i class="el-icon-caret-bottom" style="color: #bec1c5"></i>
            </div>
            <van-popup v-model="showMonth" round position="bottom">
              <van-datetime-picker
                v-model="awaitDateTime"
                type="date"
                :min-date="awaitMinDate"
                @confirm="comfirmDateTime"
                @cancel="showMonth = false"
              />
            </van-popup>
          </div>
          <div class="scroll">
            <swiper class="scrollItem" :options="awaitSwiperOption">
              <swiper-slide
                class="swiper-slide"
                v-for="(item, index) in awaitLiveList"
                :key="index"
              >
                <img
                  class="scrollImg"
                  :src="`${uploadUrl}${item.imgUrl}`"
                  alt=""
                  @click="liveJumpLink(item.jumpLink)"
                />
                <div class="scrollTitle">{{ item.liveTitle }}</div>
                <div class="titleItem">
                  <span class="titleImg">等待开播</span>
                </div>
              </swiper-slide>
              <swiper-slide
                class="swiper-slide"
                v-if="awaitLiveList.length === 1"
              ></swiper-slide>
            </swiper>
          </div>
          <div class="notAwaitLive" v-if="awaitLiveList.length < 1">
            <div class="not">暂无直播预告</div>
          </div>
        </div>
        <div class="playback">
          <div class="title">
            <div class="titleContent">往期直播</div>
            <div class="date" @click="playback">
              {{ playbackDate }}
              <i class="el-icon-caret-bottom" style="color: #bec1c5"></i>
            </div>
            <van-popup v-model="backShowMonth" round position="bottom">
              <van-datetime-picker
                v-model="BackDateTime"
                type="date"
                :formatter="formatter"
                :max-date="maxDate"
                @confirm="comfirmDateTimeBack"
                @cancel="backCancel"
              />
            </van-popup>
          </div>
          <div class="scroll">
            <swiper class="scrollItem" :options="backSwiperOption">
              <swiper-slide
                class="swiper-slide"
                v-for="(item, index) in endLiveList"
                :key="index"
              >
                <img
                  class="scrollImg"
                  :src="`${uploadUrl}${item.imgUrl}`"
                  alt=""
                  @click="liveJumpLink(item.jumpLink)"
                />

                <div class="scrollTitle">{{ item.liveTitle }}</div>
                <div class="titleItem">
                  <img class="img" src="@/assets/gzh/huifang.png" alt="" />
                  <span class="titleImg">看回放</span>
                </div>
              </swiper-slide>
              <swiper-slide
                class="swiper-slide"
                v-if="endLiveList.length === 1"
              ></swiper-slide>
            </swiper>
          </div>
          <div class="notAwaitLive" v-if="endLiveList.length < 1">
            <div class="not">暂无回放</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import apis from "@/apis/gzh.js";
export default {
  name: "liveStreaming",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      navTabsList: [],
      liveDataList: [],
      activeIndex: 0,
      currentLiveList: [],
      awaitLiveList: [],
      endLiveList: [],
      activeName: null,
      awaitDateTime: new Date(),
      awaitLiveDate: "",
      BackDateTime: new Date(),
      maxDate: new Date(),
      playbackDate: "",
      awaitMinDate: new Date(),
      // maxDate: new Date(),
      showMonth: false,
      backShowMonth: false,
      //本月轮播
      currentSwiperOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        loopedSlides: 1,
        loopAdditionalSlides: 0,
        slidesPerView: "auto",
        effect: "coverflow",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -40,
          depth: 110,
          modifier: 1,
          slideShadows: false
        }
      },
      navBarId: "",
      backSwiperOption: {
        // direction: "horizontal", //默认horizontal, 水平轮播
        // loop: true, //循环
        slidesPerView: 2, //默认1, 同时显示的slides数量,auto 代表根据轮播图的宽度排列
        spaceBetween: 9, //轮播图之间的间距
        slidesPerGroup: 1
      },

      awaitSwiperOption: {
        slidesPerView: 1.2,
        spaceBetween: 12,
        slidesPerGroup: 1
      }
    };
  },
  created() {
    this.getNavTabsData();
  },
  mounted() {
    document.title = "直播";
    this.uploadUrl = apis.uploadUrl;
    this.playbackDate = moment(this.BackDateTime).format("MM月DD YYYY年");
    this.awaitLiveDate = moment(this.awaitDateTime).format("MM月DD YYYY年");
  },
  methods: {
    // 获取直播导航
    getNavTabsData() {
      const json = {
        page: 1,
        pageSize: 100
      };
      apis.liveChannelPageList(json).then(res => {
        if (res.code === 200) {
          this.navTabsList = res.data;
          this.activeName = res.data[0].id;
          this.displayLive();
          this.awaitDisplayLive();
          this.backDisplayLive();
        }
      });
    },
    // 直播中
    displayLive() {
      const json = {
        liveStatus: "5",
        channelId: this.activeName,
        page: 1,
        pageSize: 200
      };
      apis.liveSearchDataList(json).then(res => {
        if (res.code === 200) {
          this.currentLiveList = this.filterJumpLink(res.data);
        }
      });
    },
    // 待直播
    awaitDisplayLive() {
      const json = {
        liveStatus: "6",
        channelId: this.activeName,
        waitLiveTime: moment(this.awaitDateTime).format("YYYY-MM-DD"),
        page: 1,
        pageSize: 200
      };
      apis.liveSearchDataList(json).then(res => {
        if (res.code === 200) {
          this.awaitLiveList = this.filterJumpLink(res.data);
        }
      });
    },
    // 看回放
    backDisplayLive() {
      const json = {
        liveStatus: "7",
        channelId: this.activeName,
        watchReplayTime: moment(this.BackDateTime).format("YYYY-MM-DD"),
        page: 1,
        pageSize: 200
      };
      apis.liveSearchDataList(json).then(res => {
        if (res.code === 200) {
          this.endLiveList = this.filterJumpLink(res.data);
        }
      });
    },
    // 初始化
    getLiveListData() {
      this.displayLive();
      this.awaitDisplayLive();
      this.backDisplayLive();
    },

    // 待回放 时间
    seleteDate() {
      this.showMonth = true;
    },
    // 看回放时间
    playback() {
      this.backShowMonth = true;
    },

    filterJumpLink(data) {
      return data.filter(item => {
        if (item.jumpLink.indexOf("http") !== -1) {
          item.jumpLink = "http" + item.jumpLink.split("http")[1];
        }
        if (item.jumpLink.indexOf("https") !== -1) {
          item.jumpLink = "https" + item.jumpLink.split("https")[1];
        }
        return item;
      });
    },
    // 待直播 时间确认
    comfirmDateTime(val) {
      this.awaitDateTime = val;
      this.awaitLiveDate = moment(val).format("MM月DD YYYY年");
      this.awaitDisplayLive();
      this.showMonth = false;
    },
    // 看回放 时间确认
    comfirmDateTimeBack(val) {
      this.BackDateTime = val;
      this.playbackDate = moment(val).format("MM月DD YYYY年");
      this.backDisplayLive();
      this.backShowMonth = false;
    },
    // 看回放 时间取消
    backCancel() {
      this.backShowMonth = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    // 直播跳转链接
    liveJumpLink(jumpLink) {
      window.open(jumpLink);
      // window.location.href=jumpLink
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #liveStreaming {
    width: 100%;
  }
  .tabList {
    width: 100%;
  }
  .liveContent {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #liveStreaming {
    width: 276px * $zoom;
  }
  .tabList {
    width: 276px * $zoom;
  }
  .liveContent {
    width: 276px * $zoom;
  }
}
#liveStreaming {
  font-size: 16px * $zoom;
  .tabList {
    height: 80px;
    position: fixed;
    top: 0;
    z-index: 999;
    display: flex;
    padding-top: 30px;
    background-color: #fff;
    padding: 0 20px;
    ::v-deep(.van-tabs) {
      width: 100%;
    }
    ::v-deep(.van-tab) {
      font-size: 29px;
      color: #666666;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    ::v-deep(.van-tabs__line) {
      width: 54px;
      height: 13px;
      background-color: #00c688;
      border-radius: 0;
      bottom: 39px;
    }
    ::v-deep(.van-tab--active) {
      color: #282b32;
      font-size: 37px;
      font-weight: 600;
    }
  }
  .liveContent {
    display: flex;
    justify-content: center;
    margin-top: 80px;
    .inputContent {
      width: 100%;
      .liveStreaming {
        .title {
          padding-left: 36px;
          margin: 36px 0;
          .titleContent {
            width: 160px;
            height: 37px;
            font-size: 29px;
            border-left: 10px solid #00c688;
            padding-left: 15px;
          }
        }

        .notAwaitLive {
          display: flex;
          justify-content: center;
          align-items: center;
          .not {
            width: 567px;
            height: 245px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 33px;
          }
        }
        .swiper-wrapper {
          width: 100%;
          height: 505px;
        }
        .swiper-slide {
          width: 562px;
          height: 434px;
          position: relative;
          .swiperImg {
            width: 562px;
            height: 434px;
          }
          .scrollTitle {
            font-size: 29px;
            font-weight: 800;
            text-align: center;
            color: #282b32;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .titleItem {
            width: 166px;
            height: 45px;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 10px;
            position: absolute;
            top: 15px;
            left: 20px;
            display: flex;
            align-items: center;
            .moveLive {
              width: 36px;
              height: 36px;
              background-color: #ff6e6e;
              border-radius: 50% !important;
              transform: rotate(180deg);
              display: flex;
              justify-content: center;
              margin: 0 8px 0 5px;
              .lineOne {
                width: 4px;
                height: 20px;
                background-color: #fff;
                animation: one 1s 0.5s linear infinite alternate;
                margin-top: 6px;
                border-radius: 2px;
              }
              .lineTwo {
                width: 4px;
                height: 15px;
                background-color: #fff;
                animation: one 1s 1.5s linear infinite alternate;
                margin: 0 5px;
                margin-top: 6px;
                border-radius: 2px;
              }
              .lineThree {
                width: 4px;
                height: 10px;
                background-color: #fff;
                animation: one 1s 2s linear infinite alternate;
                margin-top: 6px;
                border-radius: 2px;
              }
            }
            .img {
              width: 26px;
              height: 26px;
              margin-right: 5px;
            }
            .titleImg {
              font-size: 26px;
              color: #fff;
            }
          }
        }
      }
      .nowLiveStreaming {
        padding: 0 36px;
        .title {
          margin: 36px 0;
          display: flex;
          justify-content: space-between;
          .titleContent {
            width: 160px;
            height: 37px;
            font-size: 29px;
            border-left: 10px solid #00c688;
            padding-left: 15px;
          }
          .date {
            font-size: 29px;
            height: 37px;
            line-height: 37px;
            margin-top: 5px;
          }
        }

        .scroll {
          width: 100%;
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;

          &::-webkit-scrollbar {
            display: none;
          }

          .scrollItem {
            .swiper-slide {
              width: 497px;
              height: 330px;
              margin-right: 30px;
              position: relative;
              &:last-child {
                margin-right: 0;
              }
              .scrollImg {
                width: 497px;
                height: 280px;
              }
              .scrollTitle {
                font-size: 28px;
                font-weight: 600;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .titleItem {
                width: 116px;
                height: 45px;
                background-color: #ff8b00;
                border-radius: 10px;
                position: absolute;
                top: 15px;
                left: 20px;
                display: flex;
                align-items: center;
                justify-content: center;

                .img {
                  width: 26px;
                  height: 26px;
                }
                .titleImg {
                  font-size: 22px;
                }
              }
            }
          }
        }
        .notAwaitLive {
          display: flex;
          justify-content: center;
          align-items: center;
          .not {
            width: 497px;
            height: 280px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 33px;
          }
        }
      }
      .playback {
        padding: 0 36px;
        .title {
          margin: 36px 0;
          display: flex;
          justify-content: space-between;
          .titleContent {
            width: 160px;
            height: 37px;
            font-size: 29px;
            border-left: 10px solid #00c688;
            padding-left: 15px;
          }
          .date {
            font-size: 29px;
            height: 37px;
            line-height: 37px;
            margin-top: 5px;
          }
        }
        .scroll {
          width: 100%;
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;
          &::-webkit-scrollbar {
            display: none;
          }
          .scrollItem {
            .swiper-slide {
              width: 301px;
              height: 231px;
              margin-right: 30px;
              position: relative;
              &:last-child {
                margin-right: 0;
              }
              .scrollImg {
                width: 301px;
                height: 171px;
              }
              .scrollTitle {
                font-size: 28px;
                font-weight: 600;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .titleItem {
                width: 116px;
                height: 45px;
                background-color: #ff6e6e;
                border-radius: 10px;
                position: absolute;
                top: 15px;
                left: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                .img {
                  width: 26px;
                  height: 26px;
                  margin-right: 5px;
                }
                .titleImg {
                  font-size: 22px;
                }
              }
            }
          }
        }
        .notAwaitLive {
          display: flex;
          justify-content: center;
          align-items: center;
          .not {
            width: 301px;
            height: 271px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 33px;
          }
        }
      }
      .notLive {
        text-align: center;
        margin-top: 48%;
        font-size: 33px;
      }
    }
  }

  ::v-deep .van-tab__pane,
  .van-tab__pane-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
@keyframes one {
  0% {
    height: 0px;
  }

  30% {
    height: 10px;
  }
  60% {
    height: 15px;
  }

  100% {
    height: 20px;
  }
}
</style>
